import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {Table, Input, Label, Row, Col, Button} from 'reactstrap';
import {sharedLabelsPath} from '../../../reducers/common/localization';
import IconContainer from '../../commonComponents/iconContainer/IconContainer';
import FormWrapper from '../../commonComponents/formWrapper/FormWrapper.container';
import PaginationValidatedDomains
    from '../../commonComponents/paginationComponent/PaginationValidatedDomains.container';
import {Utils} from '../../../utils/utils';
import Select from '../../commonComponents/customSelect/CustomSelect.container';
import './ValidatedDomainsList.css';
import AddValidatedDomainModal from '../accreditationModal/validateDomainModal/AddValidatedDomainModal.container';
import EditValidatedDomainModal
    from '../accreditationModal/validateDomainModal/EditValidatedDomainModal.container';
import RemoveValidatedDomainModal
    from '../accreditationModal/removeValidatedDomainModal/RemoveValidatedDomainModal.container';
import ApplicantRequestsModal from '../accreditationModal/applicantRequestsModal/ApplicantRequestsModal.container';

const SUCCESS_MESSAGE_BY_ACTION = {
    ADD: 'validated_domains.add_success_message',
    EDIT: 'validated_domains.edit_success_message',
    REMOVE: 'validated_domains.remove_success_message',
}

class ValidatedDomainsList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            filterName: '',
            filterDomain: '',
            filtering: false,
            selectedRowData: null,
            continentCode: this.props.continentCode,
            countryFilter: null,
        }
    }

    componentDidMount() {
        this.props.onMount();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (this.state.continentCode !== nextProps.continentCode && !nextProps.modalOpen) {
            this.setState({continentCode: nextProps.continentCode})
        }

        if (this.props.modalOpen && !nextProps.modalOpen) {
            this.props.onSetContinent(this.state.continentCode);
        }

        if (!this.props.modalOpen && nextProps.modalOpen) {
            this.props.onSetContinent(null);
        }
    }

    render() {
        return (
            <div className='validated-domains-list-container'>
                <FormWrapper
                    successMessage={this.state.successMessage}>
                    <h4 className='page-label'>{_.get(this.props.translation, 'validated_domains.validated_domains_label')}</h4>
                    <div className="buttons-group">
                        <Button onClick={this.handleAddButtonClick}
                                className='add-domain-button olive-green-btn'>{_.get(this.props.translation, 'validated_domains.add_domain_button')}</Button>
                    </div>
                    {this.renderContinentAndCountryFilter()}
                    <PaginationValidatedDomains/>
                    {this.renderTable()}
                    <AddValidatedDomainModal/>
                    <EditValidatedDomainModal data={this.state.selectedRowData} onClose={this.handleCloseModal}/>
                    <ApplicantRequestsModal data={this.state.selectedRowData}/>
                    <RemoveValidatedDomainModal data={this.state.selectedRowData} onClose={this.handleCloseModal}/>
                </FormWrapper>
            </div>
        );
    }

    renderContinentAndCountryFilter = () => {
        let continentsOptions = [
            {value: null, label: _.get(this.props.translation, sharedLabelsPath.all_label)},
            ...Utils.getLocationOptions(
                this.props.continents,
                _.get(this.props.translation, sharedLabelsPath.continents)
            )
        ];

        let countriesOptions = [
            {value: null, label: _.get(this.props.translation, sharedLabelsPath.all_label)},
            ...Utils.getLocationOptions(
                this.props.countries,
                _.get(this.props.translation, sharedLabelsPath.countries)
            )
        ];

        return (
            <div className="filters-container">
                <div className="continent-filter-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.continent_label)}</h6>
                    <Select
                        className="continent-filter-select"
                        selectedOption={_.find(continentsOptions, option => option.value === this.state.continentCode || (_.isEmpty(option.value) && _.isEmpty(this.state.continentCode)))}
                        options={continentsOptions}
                        onSelect={this.handleChangeContinentSelect}
                    />
                </div>
                <div className="country-filter-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.country_label)}</h6>
                    <Select
                        className="country-filter-select"
                        selectedOption={_.find(countriesOptions, option => option.value === this.state.countryFilter)}
                        options={countriesOptions}
                        onSelect={this.handleChangeCountrySelect}
                    />
                </div>
            </div>
        )
    };

    renderTable = () => {
        if (!this.state.filtering && this.props.loading && (_.isNil(this.props.data) || this.props.data.length === 0)) {
            return (
                <div className="validated-domains-list-status-message-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }
        if (!this.state.filtering && (_.isNil(this.props.data) || this.props.data.length === 0)) {
            return (
                <div className="validated-domains-list-status-message-container">
                    <h6>{_.get(this.props.translation, 'validated_domains.no_data_label')}</h6>
                </div>
            );
        }

        return [
            <Row className='validated-domains-list-relative-header' key='relative-header'>
                <Label for='domain-input'
                       className='relative-header-label'
                       sm={2}>{_.get(this.props.translation, 'accreditation_requests.filter_by_domain_label')}:</Label>
                <Col sm={3}>
                    <Input value={this.state.filterDomain}
                           onChange={this.handleChangeFilterValue('filterDomain')}
                           placeholder={_.get(this.props.translation, 'accreditation_requests.filter_by_domain_label')}/>
                </Col>
                <Label for='name-input'
                       className='relative-header-label'
                       sm={2}>{_.get(this.props.translation, 'validated_domains.filter_by_name_label')}:</Label>
                <Col sm={3}>
                    <Input value={this.state.filterName}
                           onChange={this.handleChangeFilterValue('filterName')}
                           placeholder={_.get(this.props.translation, 'validated_domains.filter_by_name_label')}/>
                </Col>
                <Col sm={2}>
                    <Button className='olive-green-btn' onClick={this.handleFilter}>
                        {_.get(this.props.translation, 'accreditation_requests.filter_label')}
                    </Button>
                </Col>
            </Row>,
            <Table className='validated-domains-list-table' key='accreditation-requests-list-table'>
                <thead>
                <tr>
                    <th className='domain-th'>
                        {_.get(this.props.translation, 'accreditation_requests.organization_domain_label')}
                        <Input id='domain-input'
                               value={this.state.filterValue}
                               onChange={this.handleChangeFilterValue('filterDomain')}
                               onKeyDown={this.handleKeyDown}
                               onBlur={this.handleFilter}
                               className='domain-filter-input'
                               bsSize='sm'
                               placeholder={_.get(this.props.translation, 'accreditation_requests.filter_by_domain_label')}/>
                    </th>
                    <th className='name-th'>
                        {_.get(this.props.translation, 'validated_domains.organization_name_label')}
                        <Input id='name-input'
                               value={this.state.filterValue}
                               onChange={this.handleChangeFilterValue('filterName')}
                               onKeyDown={this.handleKeyDown}
                               onBlur={this.handleFilter}
                               className='name-filter-input'
                               bsSize='sm'
                               placeholder={_.get(this.props.translation, 'validated_domains.filter_by_name_label')}/>
                    </th>
                    <th className='managed-by-th'>
                        {_.get(this.props.translation, 'validated_domains.managed_by_label')}
                    </th>
                    <th className='applicant-requests-th'/>
                    <th className='remove-icon-th'/>
                </tr>
                </thead>
                <tbody>
                {this.renderValidatedDomainsData()}
                </tbody>
            </Table>
        ]
    };

    renderValidatedDomainsData = () => {
        return _.map(this.props.data, (data, index) => (
            <tr className="validated-domains-list-row" key={index} onClick={this.handleRowClick(data)}>
                <td className='domain-td'
                    data-th={_.get(this.props.translation, 'accreditation_requests.organization_domain_label') + ':'}>
                    <div className='td-with-icon'>
                        {data.orgDomain}
                        <IconContainer icon='create'
                                       key={index + '-create'}
                                       className="create-domain-icon"/>
                    </div>
                </td>
                <td className='name-td'
                    data-th={_.get(this.props.translation, 'validated_domains.organization_name_label') + ':'}>
                    {data.orgName}
                </td>
                <td className='managed-by-td'
                    data-th={_.get(this.props.translation, 'validated_domains.organization_name_label') + ':'}>
                    {_.get(this.props.translation, 'validated_domains.' + data.managedBy + '_label')}
                </td>
                <td className='applicant-requests-td'>
                    <Button className="btn-sm" color="link" onClick={this.handleApplicantRequestsButtonClick(data)}>
                        {_.get(this.props.translation, 'validated_domains.applicant_requests_label')}
                    </Button>
                </td>
                <td className='remove-icon-td' onClick={this.handleRemoveIconClick(data)}>
                    <IconContainer icon='trash'
                                   key={data.id + '-trash'}
                                   className="trash-accreditation-request-icon"
                                   title={_.get(this.props.translation, 'accreditation_requests.remove_accreditation_request_label')} />
                </td>
            </tr>
        ))
    };

    handleChangeContinentSelect = (selectedOption) => {
        this.setState({countryFilter: selectedOption.value});
        this.props.onSetContinent(selectedOption.value);
    };

    handleChangeCountrySelect = (selectedOption) => {
        this.setState({countryFilter: selectedOption.value});
        this.setState({filtering: !!selectedOption.value || !_.isEmpty(this.state.filterName) || !_.isEmpty(this.state.filterDomain)});
        this.props.onChangeCountryFilter(selectedOption.value);
    };

    handleChangeFilterValue = (fieldKey) => (e) => {
        this.setState({[fieldKey]: e.target.value, filtering: true});
    };

    handleRemoveIconClick = (data) => (e) => {
        e.stopPropagation();
        this.setState({
            selectedRowData: data,
            successMessage: _.get(this.props.translation, SUCCESS_MESSAGE_BY_ACTION.REMOVE)
        });
        this.props.onRemove();
    };

    handleKeyDown = (e) => {
        if (e.keyCode === 13) {
            this.handleFilter();
        }
    };

    handleFilter = () => {
        if (_.isEmpty(this.state.filterName) && _.isEmpty(this.state.filterDomain)) {
            this.setState({filtering: false});
        }
        this.props.onFilter(this.state.filterName, this.state.filterDomain);
    };

    handleApplicantRequestsButtonClick = (data) => (e) => {
        e.stopPropagation();
        this.setState({selectedRowData: {requestsNumber: data.requestsNumber}});
        this.props.onShowApplicantRequests(data.orgDomain);
    }

    handleAddButtonClick = () => {
        this.setState({successMessage: _.get(this.props.translation, SUCCESS_MESSAGE_BY_ACTION.ADD)});
        this.props.onAddDomain();
    }

    handleRowClick = (data) => () => {
        this.setState({
            selectedRowData: data,
            successMessage: _.get(this.props.translation, SUCCESS_MESSAGE_BY_ACTION.EDIT)
        });
        this.props.onEditDomain();
    }

    handleCloseModal = () => {
        this.setState({selectedRowData: null});
    }
}

ValidatedDomainsList.propTypes = {
    loading: PropTypes.bool,
    translation: PropTypes.object.isRequired,
    data: PropTypes.array,
    continents: PropTypes.array,
    continentCode: PropTypes.string,
    countries: PropTypes.array,
    modalOpen: PropTypes.bool,
    onMount: PropTypes.func.isRequired,
    onChangeCountryFilter: PropTypes.func.isRequired,
    onSetContinent: PropTypes.func.isRequired,
    onFilter: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    onAddDomain: PropTypes.func.isRequired,
    onEditDomain: PropTypes.func.isRequired,
    onShowApplicantRequests: PropTypes.func.isRequired,
};

export default ValidatedDomainsList;



// WEBPACK FOOTER //
// ./src/components/accreditationManagement/validatedDomainsList/ValidatedDomainsList.js